import {initWebComponent} from "@/helpers/web-component-helper";
import {OlComponent} from "@/components/ol/ol-component";
import {LayoutHeaderComponent} from "@/components/layout/layout-header-component";
import {LayerMenuComponent} from "@/components/layer/menu/layer-menu-component";
import {LayerInfoComponent} from "@/components/layer/info/layer-info-component";
import {LayoutFooterComponent} from "@/components/layout/layout-footer-component";
import {LanguageComponent} from "@/components/language/language-component";
import {initLanguage} from "@/modules/language/language";
import {initFeedback} from "@/helpers/feedback-helper";
import {isMobile} from "@/helpers/mobile-helper";
import {
    BookmarkUserSessionModalComponent
} from "@/components/bookmark/usersession/bookmark-user-session-modal-component";
import {LayoutAboutComponent} from "@/components/layout/layout-about-component";
import {OlBackgroundSwitcherComponent} from "@/modules/ol/ol-background-switcher";
import {getBySelector} from "@/helpers/element-helper.js";
import {showCyclo} from "@/components/layer/info/info/plugin/layer-info-info-plugin-cyclorama-component.js";
import {LayerMenuCompareComponent} from "@/components/layer/menu/compare/layer-menu-compare-component.js";


export class LayoutComponent extends HTMLElement {
    constructor() {
        super();

        const url = this.getAttribute('url')
        const website = this.getAttribute('website')

        let layerMenuHidden = ''
        if(isMobile() || [1,2].includes(window.settings.MenuLagenStartup)) {
            layerMenuHidden = 'd-none'
        }

        const template = document.createElement('template');
        let innerHTML = `<div class="layout-wrapper layout-1 layout-without-sidenav material-style layout-navbar-fixed">`

        if(!isMobile()) {
            innerHTML += `<layout-header></layout-header>`
        }

        innerHTML += `
    <layout-about></layout-about>
    <div class="layout-container">
      <div class="layout-content">
        <div class="container-fluid flex-grow-1 container-p-y pl-0 pr-0">
          <header-search class="d-block d-md-none"></header-search>
          <layer-menu class="` + layerMenuHidden + `"></layer-menu>
          <layer-info></layer-info>
          <ol-map id="map" tabindex="0"></ol-map>
        </div>
        <layout-footer></layout-footer>
        <ol-background-switcher></ol-background-switcher>
        <layer-menu-compare class="d-none"></layer-menu-compare>
      </div>
    </div>
      <!-- Layout inner -->
    </div>
    <bookmark-user-session-modal></bookmark-user-session-modal>
`;

        template.innerHTML = innerHTML

        initWebComponent(this, template)

        initLanguage()


        try {
            const bc = new BroadcastChannel('cyclorama_channel');

            let visible = true
            if (window.mainTabs && window.mainTabs.length > 0) {
                visible = window.mainTabs[0].BookmarkPresentationID === window.cycloramaBookmarkPresentationID
            }

            bc.onmessage = function (ev) {

                if(document.querySelector('.nav-link-info-header.active')) {
                    visible = parseInt(document.querySelector('.nav-link-info-header.active').closest('layer-info-info-item-header').dataset.bookmarkPresentationName) === window.cycloramaBookmarkPresentationID
                }

                if(getBySelector('bookmark-right-mouse-button').offsetHeight > 0) {
                    visible = true
                }

                const data = ev.data
                showCyclo(data.recording.xyz[0], data.recording.xyz[1], data.orientation.yaw, data.orientation.pitch, data.orientation.hFov, visible);
            }
        } catch (e) {
            console.log(e)
        }
    }
}

window.customElements.define("layout-language", LanguageComponent);

window.customElements.define("ol-map", OlComponent);
window.customElements.define("layout-header", LayoutHeaderComponent);
window.customElements.define("layer-menu", LayerMenuComponent);
window.customElements.define("layer-info", LayerInfoComponent);
window.customElements.define("layout-footer", LayoutFooterComponent);
window.customElements.define("layout-about", LayoutAboutComponent);
window.customElements.define("bookmark-user-session-modal", BookmarkUserSessionModalComponent);
window.customElements.define("ol-background-switcher", OlBackgroundSwitcherComponent);
window.customElements.define("layer-menu-compare", LayerMenuCompareComponent);
